export default __webpack_public_path__ + "static/upward_movement-a4c8c415d4af8eb6f95d83572a067867.svg";